/* eslint-disable no-alert */
import React from 'react'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import moment from 'moment'
import { Icon, Button, Header, Form, Modal } from 'semantic-ui-react'
import { map } from 'lodash'

import AppCustomizationActions from '../../../../reducers/appCustomizationReducer'

import ImagePicker from '../../../../components/common/imagePicker'
import ImageUploader from '../../../../services/ImageUpload'

class EntryCategoryForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    categoryKey: null,
    title: '',
    imageUrl: null,
    compressImageUrl: null,

    hasUploadedImage: false,
    loading: false,
  }

  componentDidMount() {
    const { category } = this.props

    if (category) {
      this.setState({
        title: category.title,
        categoryKey: category.id,
        imageUrl: category.image_url,
        compressImageUrl: category.compress_image_url,
      })
    }
  }

  onCategoryChange = data => {
    const { categories } = this.props
    const { hasUploadedImage, imageUrl, compressImageUrl } = this.state

    const newImageUrl = hasUploadedImage ? imageUrl : categories[data.value].image
    const newCompressImageUrl = hasUploadedImage ? compressImageUrl : categories[data.value].compress_image

    this.setState({ categoryKey: data.value, imageUrl: newImageUrl, compressImageUrl: newCompressImageUrl })
  }

  afterUpload = async (file, name, imageUrl) => {
    try {
      const imageUploader = new ImageUploader(file, name, {
        destination: 'images/app-customization/entry/categories',
        originalUrl: imageUrl,
        type: 'entcat_image',
        manipulation: {
          width: 700,
          height: 0,
          size: 15000,
        },
      })
      const { data } = await imageUploader.createWebpVersion()
      this.setState({ compressImageUrl: data })
    } catch (err) {
      alert('There is problem while uploading file. Please try again.', err)
    }
  }

  // eslint-disable-next-line consistent-return
  onSubmit = async e => {
    e.preventDefault()

    const { onClose, setSingleCustomization, category } = this.props
    const { categoryKey, title, imageUrl, compressImageUrl } = this.state

    if (!categoryKey || !title || !imageUrl) return alert('Please complete all fields')

    this.setState({ loading: true })

    try {
      const updates = { title, image_url: imageUrl, compress_image_url: compressImageUrl }

      if (!category) updates.created_at = Number(moment().format('x'))

      await firebase
        .firestore()
        .collection('app_customization')
        .doc('entry')
        .collection('categories')
        .doc(categoryKey)
        .set(updates, { merge: true })

      setSingleCustomization({
        screen: 'entry',
        resource: 'categories',
        data: { ...updates, id: categoryKey },
      })
      onClose()
    } catch (error) {
      alert(error.message)
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    const { visible, category, categories, onClose } = this.props
    const { title, categoryKey, imageUrl, loading } = this.state

    const modalTitle = category ? 'Edit Category' : 'Add Category'

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={modalTitle} />
        <Modal.Content>
          <Form
            onSubmit={this.onSubmit}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            <Form.Group widths="equal">
              <Form.Select
                required
                search
                fluid
                disabled={category || loading}
                label="Category"
                options={map(categories, (c, key) => ({ key, value: key, text: c.name }))}
                onChange={(e, data) => this.onCategoryChange(data)}
                value={categoryKey}
              />
            </Form.Group>
            {categoryKey && (
              <React.Fragment>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    label="Title"
                    onChange={e => this.setState({ title: e.target.value })}
                    value={title}
                  />
                </Form.Group>
                <ImagePicker
                  compress
                  label="Image"
                  url={imageUrl}
                  uploadOriginal={false}
                  afterUpload={this.afterUpload}
                  compressFileName={categoryKey}
                  uploadPath="app-customization/entry/categories"
                  onCompressCompleted={url => this.setState({ imageUrl: url, hasUploadedImage: true })}
                />
              </React.Fragment>
            )}

            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapDispatch = {
  setSingleCustomization: AppCustomizationActions.setSingleCustomization,
}

export default connect(
  null,
  mapDispatch
)(EntryCategoryForm)



// WEBPACK FOOTER //
// ./src/containers/appCustomization/components/EntryCategories/form.js